<template>
  <div class="loading-frames">
    <div class="loading-frames__spinner" />
    <div class="loading-frames__content">{{ $t('Loading animation') }} - {{ count }}</div>
  </div>
</template>

<script>
export default {
  name: "LoadingFrames",
  props: {
    count: {
      type: String,
      default: '0/72'
    }
  }
};
</script>

<style lang="sass" scoped>
.loading-frames
    position: absolute
    top: 40px
    right: 15px
    font-size: .85rem
    color: gray
    padding: .5rem
    background-color: white
    border-radius: .5rem
    align-items: center
    display: flex
    z-index: 2

    @media screen and (min-width: 901px)
        right: 120px
        top: unset
        bottom: 40px

    &__content
        line-height: 100%
        display: none

        @media screen and (min-width: 768px)
          display: block

    &__spinner
        width: 1.25rem
        height: 1.25rem
        position: relative

        @media screen and (min-width: 768px)
          margin-right: .5rem

        &:before
            content: ''
            box-sizing: border-box
            position: absolute
            top: 50%
            left: 50%
            width: 100%
            height: 100%
            margin-top: -10px
            margin-left: -10px
            border-radius: 50%
            border: 2px solid #ccc
            border-bottom-color: #ec9000
            animation: spinner 1s linear infinite

    @keyframes spinner
        to
            transform: rotate(360deg)
</style>
